import React, {useState, useEffect } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import ALoader from 'views/pages/manage/common/a-loader';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Tooltip } from '@mui/material';
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { Card, CardBody } from 'reactstrap';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import moment from 'moment';
import { statusMapping, statusStyle } from './constant';
//import StatusCellComponent from "./StatusCellComponent";

const Logs = ({
    loader,
    rowList,
    rowCount,
    getDetailLogs
}) => {
    // const [rows, setRows] = useState(rowList)
    // const [currentPage, setCurrentPage] = useState(0);
    const [open, setOpen] = useState(true)

    // const [logsLoader, setLogsLoader] = useState(false)
    // useEffect(() => {
    //     setRows(rowList)
    // }, [])
    // const onChangeHandler = async (page) => {
    //     setCurrentPage(page)
    //     setLogsLoader(true)
    //     await getDetailLogs(page)
    //     setLogsLoader(false)
    // }

    const columns = [
        new AGridColDef("title", "Events", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("value", "Value", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("updatedOn", "Updated On", true)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')}`}>
                    <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("status", "Status", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(0.50)
            .columnAlign('right')
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={statusMapping?.[(params?.value).toUpperCase()]??(params?.value).toUpperCase()}>
                    <div className={`ellipsis-text-container`} style={statusStyle?.[statusMapping?.[(params?.value).toUpperCase()]]}>{statusMapping?.[(params?.value).toUpperCase()]??(params?.value).toUpperCase()}</div>
                </Tooltip> : <div>-</div>
            ))

    ]
    return (

            
                <Card>
                    <CardBody>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='dark-text label-color'>Logs</div>
                            <div className="cursor" onClick={() => { setOpen((prev) => (!prev)) }}>{open ? <Uparrow /> : <DownArrow />}</div>
                        </div>
                        {open && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        {loader &&<ALoader position="fixed" /> }
                        <ADataGrid
                                removeWrapperContainer
                                // rowModesModel={rowModesModel}
                                rows={rowList || []}
                                columns={columns}
                                rowId={(row) => JSON.stringify(row)}
                                rowHeight={50}
                                loading={false}
                                rowCount={rowCount}
                                components={{
                                    ...gridComponents,
                                    NoRowsOverlay: () => (
                                        <NoRowOverlay message={loader ? "Loading..." : null} />
                                    ),
                                }}
                                sx={gridStyles}
                                //  pageSize={10}
                                serverPagination={false}
                                autoHeight
                                pinLastColumn
                             hidePagination={true}
                            /></>}
                    </CardBody>
                </Card>

    )
}

export default Logs